// The component-library version of Manage Expiring Leases (property-level).
// Composes `TableLayout`, `TableHeader`, the info-card quick filter and the
// library `Table`, following `AllManageLeaseExpirations/index.js`. Unlike
// that portfolio container, `useManageExpiringLeases` reads
// `organizationId`/`propertyId` itself, so this component needs no Redux
// connect and owns no selected-card state — the hook owns that.
import React from 'react';
import DocumentTitle from 'react-document-title';
import {
  Table,
  TableHeader,
} from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import { useManageExpiringLeases } from './hooksV2';
import { NAME } from './constantsV2';
import LeaseInfoCardsV2 from './LeaseInfoCardsV2';
import TableLayout from '../../components/TableLayout';
import useBaseTableProps from '../../hooks/useBaseTableProps';

const TITLE = 'Manage Expiring Leases';

const ManageLeaseExpirationsV2 = () => {
  const baseTableProps = useBaseTableProps();

  const {
    allColumnsHidden,
    columnOptions,
    count,
    dateState,
    filterState,
    filterTypeState,
    filteredHeaders,
    handleBucketChange,
    handleColumnChange,
    handleDateSubmit,
    handleFilterChange,
    handleFilterTypeChange,
    handleSearchSubmit,
    handleSortChange,
    isLoading,
    metrics,
    name,
    onCSVButtonClick,
    order,
    orderBy,
    rows,
    searchState,
    selectedBucketId,
    selectedColumns,
    totalCount,
  } = useManageExpiringLeases({ NAME });

  return (
    <DocumentTitle data-testid={NAME} title={TITLE}>
      <TableLayout name={name} childrenElementsHeight={50 + 8 + 178}>
        {(tableHeight) => (
          <>
            <TableHeader title={TITLE} count={count} totalCount={totalCount} />
            <LeaseInfoCardsV2
              metrics={metrics}
              onChange={handleBucketChange}
              selectedBucketId={selectedBucketId}
            />
            <Table
              {...baseTableProps}
              allColumnsHidden={allColumnsHidden}
              columnOptions={columnOptions}
              count={count}
              dateState={dateState}
              filterState={filterState}
              filterTypeState={filterTypeState}
              handleColumnChange={handleColumnChange}
              handleDateSubmit={handleDateSubmit}
              handleFilterChange={handleFilterChange}
              handleFilterTypeChange={handleFilterTypeChange}
              handleSearchSubmit={handleSearchSubmit}
              handleSortChange={handleSortChange}
              headers={filteredHeaders}
              height={tableHeight}
              isLoading={isLoading}
              name={name}
              onCSVButtonClick={onCSVButtonClick}
              order={order}
              orderBy={orderBy}
              rows={rows}
              searchState={searchState}
              selectedColumns={selectedColumns}
              totalCount={totalCount}
            />
          </>
        )}
      </TableLayout>
    </DocumentTitle>
  );
};

export default ManageLeaseExpirationsV2;
